import styled from 'styled-components';

export const QR_BROADCAST_CHANNEL = 'qr-session';
export const QR_BROADCAST_ROTATE = 'rotate';
export const QR_BROADCAST_DISABLE = 'disable';
export const QR_BROADCAST_CLOSE = 'close';

export const CountdownText = styled.div`
  margin-top: 16px;
  font-size: 20px;
  color: ${props => props.$expired ? '#d32f2f' : '#666'};
`;

export const computeCountdown = (validUntil) => {
  if (!validUntil) {
    return null;
  }
  const diff = new Date(validUntil).getTime() - new Date().getTime();
  if (diff <= 0) {
    return { expired: true, text: '' };
  }
  const totalSeconds = Math.floor(diff / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return { expired: false, text: `${minutes}:${seconds.toString().padStart(2, '0')}` };
};
